import Orders from '../../services/Orders';

export default {
    namespaced: false,
    state: {
        terms: [],
        products: [],
        productsInit: [],
        orders: [],
        ids: 0
    },
    mutations: {
        SET_TERMS(state, data) {
            state.terms = data;
        },
        SET_PRODUCTS(state, data) {
            state.products = data;
        },
        SET_PRODUCTS_INIT(state, data) {
            state.productsInit = data;
        },
        SET_ORDERS(state, data) {
            state.orders = data;
        },
        SET_IDS(state, data) {
            state.ids = data;
        },
        PUSH_PRODUCTS_INIT(state, data) {
            state.productsInit = state.productsInit.concat(data);
        }
    },
    actions: {
        getTerms({ commit }) {
            const response = Orders.getTerms();
            response.then(res => {
                commit('SET_TERMS', res.data.terms);
                commit('SET_PRODUCTS_INIT', res.data.products);
                commit('SET_ORDERS', res.data.order);
                commit('SET_IDS', res.data.ids);
            });
        },
        search({ commit }, obj) {
            const response = Orders.search(obj);
            response.then(res => {
                commit('SET_PRODUCTS', res.data.products);
                commit('SET_ORDERS', res.data.order);
            });
        },
        loadMore({ commit }, arr) {
            const response = Orders.loadMore(arr);
            response.then(res => {
                commit('PUSH_PRODUCTS_INIT', res.data);
            });
        }
    }
};
